import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Montserrat, self-hosted.
//
// It used to arrive from fonts.googleapis.com, which transmits every visitor's IP to
// Google on page load — a third-party transfer with no consent behind it, and the kind
// of thing an enterprise security review finds. The variable face is one file covering
// 400-700, so this is fewer requests than the CDN was making, not more.
import '@fontsource-variable/montserrat/wght.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/searchselect.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
